import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import FormModal from 'components/organisms/FormModal/FormModal'
import RouteConst from 'constants/RouteConst'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import StringConst from '../../../../constants/StringConst'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import HotelAmenitiesService from '../../../../services/HotelAmenitiesService'
import {isArrayNotEmpty, pad, searchFirstObjectInList, searchObjectList, searchObjectListBoolean, sortObjectList, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import { isHotelDomestic } from '../../../../utilities/JSUtil'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import SelectList from '../../../atoms/form/SelectList/SelectList'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import withFormLayout from '../WithFormLayout'
import './HotelAmenities.scss'

export class HotelAmenities extends Component {

    headers = ['Code', 'Description', 'Location', 'Distance',  'Distance Unit', 'Opening Hours', 'Closing Hours', '', '', 'Charge', 'Cost', 'Delete']

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const isDomestic = isHotelDomestic(hotelInfo)

        let masterHotelAmenities = []
        let tagSpecificAmenities = []

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            initialValues: this.initialValues,
            masterHotelAmenities: masterHotelAmenities,
            tagSpecificAmenities: tagSpecificAmenities,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            distanceUnit: getSessionItem(SessionConst.DISTANCE_UNIT),
            distanceUnitLabel: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            isDomestic: isDomestic,
            onlyHiddenAmenities: false
        }
    }

    initialValues = { searchKey: '', categoryCode: '', optionsList: [], filterOptions: [{ label: '', value: '' }], filteredList: [], addIndices: [], removeIndices: [], hotelAmenities: [] }

    async componentDidMount() {
        this.refreshData()
    }

    refreshData = async () => {
        // Retrieve the status for Hotel Amenities in checklist
        // This will determine if we set tagged amenities for the brand as default selected amenities
        const checklist = this.props.checklist
        let isCompleteInChecklist = false
        if (isArrayNotEmpty(checklist)) {
            isCompleteInChecklist = searchFirstObjectInList('code', 'HOTEL_AMENITIES', checklist)?.processedFlag === FormConst.CHECKLIST_STATUS_COMPLETED
        }

        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let selectedHotelAmenities = this.state.hotelInfoCompletedHistory?.newEntity?.hotelAmenities?.hotelAmenities;

            if (selectedHotelAmenities) {
                await this.buildFormValues(selectedHotelAmenities, isCompleteInChecklist);
            }
        } else {
            // These will be the amenities under Selected Hotel Amenities table
            let selectedHotelAmenities = []
            await HotelAmenitiesService.getHotelAmenities({ hotelCode: this.state.hotelCode })
                .then(async hotelAmenitiesResponse => {
                    selectedHotelAmenities = hotelAmenitiesResponse.hotelAmenities;
                    await this.buildFormValues(selectedHotelAmenities, isCompleteInChecklist);
                }).catch(error => {
                    // Could not retrieve hotel amenities list
                    // Return home?
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while retrieving Hotel Amenities'
                    })
                });
        }
    }

    async buildFormValues(selectedHotelAmenities, isCompleteInChecklist) {
        // Initialize to empty array when missing
        // The service response should return an empty array,
        // but this is an additional check to avoid undefined access for incorrect service response
        if (!selectedHotelAmenities) {
            selectedHotelAmenities = []
        }

        // Brand specific amenities list
        let tagSpecificAmenities = []

        await HotelAmenitiesService.getMasterHotelAmenities({
            hotelCode: this.state.hotelCode, queryParams: {
                searchByTags: true
            }
        }).then(async tagSpecificAmenitiesResponse => {

            tagSpecificAmenities = tagSpecificAmenitiesResponse.masterHotelAmenities

            await HotelAmenitiesService.getMasterHotelAmenities({ hotelCode: this.state.hotelCode })
                .then(masterAmenitiesResponse => {
                    // All non tag specific master amenities
                    let masterHotelAmenities = masterAmenitiesResponse.masterHotelAmenities
                    
                    if (this.state.isDomestic && isArrayNotEmpty(masterHotelAmenities)) {
                        // Add additional default amenities to domestic properties
                        FormConst.HOTEL_DEFAULT_AMENITY_CODES.forEach(amenityToDefault => { 
                            let amenityIndex = masterHotelAmenities.map(masterAmenity => masterAmenity.code).indexOf(amenityToDefault)
                            let amenityObject = masterHotelAmenities[amenityIndex]
                            if (amenityIndex >= 0 && !tagSpecificAmenities.includes(amenityObject)) {
                                masterHotelAmenities.splice(amenityIndex, 1)
                                tagSpecificAmenities.unshift(amenityObject)
                            }
                        })
                    }
                    
                    let amenityCategories = {}
                    // Push tag specific amenities into master list
                    // - as tag specific and non tag specific entries
                    // are mutually exclusive
                    if (isArrayNotEmpty(tagSpecificAmenities) && isArrayNotEmpty(masterHotelAmenities)) {
                        masterHotelAmenities = [...tagSpecificAmenities, ...masterHotelAmenities]
                    } else if (isArrayNotEmpty(tagSpecificAmenities)) {
                        masterHotelAmenities = [...tagSpecificAmenities]
                    }

                    if (isArrayNotEmpty(masterHotelAmenities)) {
                        // String to be used for padding
                        const spaces = Array(7).join(StringConst.NBSP)

                        masterHotelAmenities.forEach((amenity, index) => {
                            // Set value to the index in this list so that it will be unique when used in any other list - unselected or selected
                            amenity.value = index
                            // Add a label to be used while displaying in the select list for unselected amenities
                            amenity.label = pad(spaces, amenity.code, false) + amenity.description
                            // Set amenityCode - property in outgoing request for code
                            amenity.amenityCode = amenity.code
                            amenity.fee = ''
                            amenity.operatingHours = {
                                open: '',
                                close: '',
                                fullDay: false
                            }
                            // Add amenity category to filter options list
                            if (amenity.amenityCategory) {
                                amenityCategories[amenity.amenityCategory.code] = amenity.amenityCategory.description
                            }
                        })

                        // Unselected amenities options list
                        let options = [...masterHotelAmenities]
                        options = sortObjectList(options, 'code')
                        // Copy properties from master list for selected amenities
                        selectedHotelAmenities?.forEach(amenity => {
                            let amenityInMaster = searchObjectList('code', amenity.amenityCode, masterHotelAmenities)[0]

                            amenity.value = amenityInMaster.value
                            amenity.label = amenityInMaster.label
                            amenity.chargePolicy = amenityInMaster.chargePolicy
                            amenity.chargeApplicable = amenity.chargeApplicable ? FormConst.VALUE_YES : FormConst.VALUE_NO
                            amenity.fee = amenity.fee ? amenity.fee : ''
                            if (amenity.proximityLocation === FormConst.VALUE_ONSITE) {
                                amenity.distance = {
                                    value: 0,
                                    unitCode: this.state.distanceUnit
                                }
                            }
                            amenity.operatingHours = {
                                open: amenity.operatingHours && amenity.operatingHours.open ? amenity.operatingHours.open : '',
                                close: amenity.operatingHours && amenity.operatingHours.close ? amenity.operatingHours.close : '',
                                fullDay: amenity.fullDay
                            }
                        })
                        selectedHotelAmenities = sortObjectList(selectedHotelAmenities, 'amenityCode')

                        // Calculate amenity categories list
                        let amenityCategoriesList = [{ label: '', value: '' }]

                        let accessibleCategories = []
                        let otherCategories = []

                        // Get accessible and other categories
                        for (const key in amenityCategories) {
                            if (amenityCategories.hasOwnProperty(key)) {
                                const element = amenityCategories[key]
                                if (element?.toUpperCase().includes('ACCESSIBLE')) {
                                    accessibleCategories.push({ label: element, value: key })
                                } else {
                                    otherCategories.push({ label: element, value: key })
                                }
                            }
                        }
                        
                        // Add accessible categories first
                        if (isArrayNotEmpty(accessibleCategories)) {
                            amenityCategoriesList = [...amenityCategoriesList, ...accessibleCategories]
                        }

                        // Add other cateories
                        if (isArrayNotEmpty(otherCategories)) {
                            sortObjectList(otherCategories, 'label')
                            amenityCategoriesList = [...amenityCategoriesList, ...otherCategories]
                        }

                        // If the checklist status for Hotel Amenities is COMPLETED,
                        // or if the service response has amenities then use the amenities from response
                        // ignoring pet and non-smoking amenities
                        // Otherwise, use tag specific amenities
                        let hotelAmenities = selectedHotelAmenities
                        
                        if (!isCompleteInChecklist &&
                            selectedHotelAmenities.every(amenity => FormConst.IGNORED_AMENITY_CODES.includes(amenity.amenityCode))) {
                            tagSpecificAmenities?.forEach(tagSpecificAmenity => {
                                if (!hotelAmenities.map(ha => ha.amenityCode).includes(tagSpecificAmenity.amenityCode)) {
                                    let amenityToSelect = { ...tagSpecificAmenity }
                                    this.updateDefaultValuesForSelectedAmenity(amenityToSelect)
                                    hotelAmenities.push(amenityToSelect)
                                }
                            })
                        }

                        // Remove selected amenities from available options
                        let filteredList = options.filter(option => !(FormConst.FEMA_AMENITY_CODE === option.code)
                                                                    && !searchObjectListBoolean('amenityCode', option.code, hotelAmenities))

                        this.setState({
                            // Master amenities list
                            masterHotelAmenities: masterHotelAmenities,
                            // Tag specific amenities list
                            tagSpecificAmenities: tagSpecificAmenities,
                            initialValues: {
                                ...this.state.initialValues,
                                // Contains all possible options, including the ones already selected
                                // Will be used to calculate filtered list
                                optionsList: options,
                                // Displays available options
                                filteredList: filteredList,
                                // Category filter options
                                filterOptions: amenityCategoriesList,
                                // Amenity search filter
                                searchKey: '',
                                // Amenity category filter
                                categoryCode: '',
                                // The selected amenities
                                hotelAmenities: hotelAmenities
                            },
                            isLoading: false
                        })
                    } else {
                        // Could not retrieve master amenities list
                        this.setState({
                            isLoading: false,
                            showErrorModal: true,
                            errorMessage: 'There was an error while retrieving Master Hotel Amenities'
                        })
                    }
                })
                .catch(error => {
                    // Could not retrieve master amenities list
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while retrieving Master Hotel Amenities'
                    })
                })
        }).catch(error => {
            // Could not retrieve master amenities list
            // Return home?
            this.setState({
                isLoading: false,
                showErrorModal: true,
                errorMessage: 'There was an error while retrieving Master Hotel Amenities'
            })
        })
    }

    validationSchema = Yup.object().shape({
        hotelAmenities: Yup.array()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .of(
                Yup.object().shape({
                    amenityCode: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    description: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    proximityLocation: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    distance: Yup.object().when('proximityLocation', {
                        is: FormConst.VALUE_NEARBY,
                        then: Yup.object().required(FormConst.VALIDATION_ERROR_REQUIRED)
                    }).shape({
                        value: Yup.number('Distance must be a number').required(FormConst.VALIDATION_ERROR_REQUIRED),
                        unitCode: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                    }),
                    operatingHours: Yup.object({
                        open: Yup.string().test('Close must have Open', function (val) {
                            if (this.parent.close !== undefined && this.parent.close !== ''
                                && (val == undefined || val == '')
                            ) {
                                return this.createError({ message: 'Open Required'})
                            }
                            return true
                        }),
                        close: Yup.string().test('Open must have Close', function (val) {
                            if (this.parent.open !== undefined && this.parent.open !== ''
                                && (val == undefined || val == '')
                            ) {
                                return this.createError({ message: 'Close Required'})
                            }
                            return true
                        }),
                    }),
                    chargeApplicable: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
            )
    })

    updateDefaultValuesForSelectedAmenity = (amenityEntry) => {

        amenityEntry.proximityLocation = FormConst.VALUE_ONSITE

        amenityEntry.distance = {
            value: 0,
            unitCode: this.state.distanceUnit
        }

        switch (amenityEntry.chargePolicy) {
            case FormConst.HOTEL_AMENITIES_CHARGE_POLICY_TYPES.CHARGE_CANNOT_BE_APPLIED:
                amenityEntry.chargeApplicable = FormConst.VALUE_NO
                break
            case FormConst.HOTEL_AMENITIES_CHARGE_POLICY_TYPES.CHARGE_DETERMINED_BY_HOTEL:
                amenityEntry.chargeApplicable = FormConst.VALUE_NO
                break
            case FormConst.HOTEL_AMENITIES_CHARGE_POLICY_TYPES.CHARGE_MUST_BE_APPLIED:
                amenityEntry.chargeApplicable = FormConst.VALUE_YES
                break
        }
    }

    addAmenity = (valueList, hotelAmenities) => {
        let values = valueList.map(index => {
            return Number(index)
        })

        let entriesToAdd = this.state.initialValues.filteredList.filter(option => values.includes(option.value))
        let remainingOptions = this.state.initialValues.filteredList.filter(option => !values.includes(option.value))
        let selected

        entriesToAdd.forEach(entry => {
            this.updateDefaultValuesForSelectedAmenity(entry)
        })

        if (isArrayNotEmpty(hotelAmenities)) {
            selected = [...entriesToAdd, ...hotelAmenities]
        } else {
            selected = [...entriesToAdd]
        }

        let initialValues = {
            ...this.state.initialValues,
            filteredList: remainingOptions,
            hotelAmenities: selected
        }

        this.setState({
            initialValues: initialValues
        })
    }

    removeAmenity = (valueList, formData) => {
        let values = valueList.map(index => {
            return Number(index)
        })

        let selected = [...formData.hotelAmenities]

        let entriesToRemove = selected.filter(option => values.includes(option.value))
        entriesToRemove = this.state.masterHotelAmenities.filter(amenity => searchObjectListBoolean('amenityCode', amenity.amenityCode, entriesToRemove))

        // Filter out the remaining selected amenities
        let remainingSelected = selected.filter(option => !values.includes(option.value))

        // Calculate the filtered list from the options list first to exclude selected hotel amenities
        // Then add the entries that we removed so that they are present at the top of the list
        let options = [...formData.optionsList]
        let filteredList = options.filter(option => !searchObjectListBoolean('amenityCode', option.code, selected))
        filteredList = [...entriesToRemove, ...filteredList]

        let initialValues = {
            ...formData,
            filteredList: filteredList,
            hotelAmenities: remainingSelected,
            searchKey: '',
            categoryCode: ''
        }

        this.setState({
            initialValues: initialValues
        })
    }

    searchOptions = (searchKey, categoryCode, values) => {
        let filteredList = []

        if (isArrayNotEmpty(values.optionsList)) {

            let options = [...values.optionsList]
            filteredList = options.filter(option => !(FormConst.FEMA_AMENITY_CODE === option.code)
                                                    && !searchObjectListBoolean('amenityCode', option.code, values.hotelAmenities))

            if (!searchKey && !categoryCode) {
                // If no filter is present, return undefined
            } else {
                // If category filter is present, first filter using the category code
                if (categoryCode) {
                    filteredList = filteredList.filter(option => option.amenityCategory.code === categoryCode)
                }

                // If search key is present, filter the remaining list with the key
                if (searchKey) {
                    filteredList = filteredList.filter(option => option.code.includes(searchKey) || option.description.toUpperCase().includes(searchKey))
                }
            }
        }
        this.setState({
            initialValues: {
                ...values,
                filteredList: filteredList,
                searchKey: searchKey,
                categoryCode: categoryCode
            }
        })
    }

    handleSubmit = (formData) => {
        let hotelAmenities = []

        // Decouple form data from the put data
        formData.hotelAmenities.forEach(amenity => {
            hotelAmenities.push({
                amenityCode: amenity.amenityCode,
                description: amenity.description,
                chargeApplicable: amenity.chargeApplicable === FormConst.VALUE_YES ? true : false,
                chargeAmount: amenity.chargeAmount,
                proximityLocation: amenity.proximityLocation,
                fee: amenity.fee,
                fullDay: amenity.operatingHours.fullDay,
                distance: {
                    ...amenity.distance
                },
                operatingHours: {
                   open: amenity.operatingHours.open,
                   close: amenity.operatingHours.close
                },
            })
        })

        

        hotelAmenities.forEach((amenity) => {
            if (amenity.proximityLocation === FormConst.VALUE_NEARBY) {
                if (amenity.hasOwnProperty('distance')) {
                    const distance = amenity['distance']
                    amenity.distance.unitDescription = this.state.distanceUnit
                }
            } else {
                amenity.distance = {
                    value: 0
                }
            }
        })

        this.props.onPut({ hotelCode: this.state.hotelCode, hotelAmenities: hotelAmenities })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    getTagSpecificAmenities = (amenityList) => {
        return amenityList.filter(amenity => searchObjectListBoolean('code', amenity.code, this.state.tagSpecificAmenities))
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({ isLoading: false, showErrorModal: true, errorMessage: this.props.errorDescription })
            } else {
                this.setState({ isLoading: false })
                this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
            }
        }
    }

    render() {
        return (
            <div id='hotel-amenities-page' className='hotel-amenities-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Hotel Amenities</li>
                    </ol>
                </nav>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm }) => (
                            <Form className='hotel-amenities-form-element'>
                                <p className='hotel-amenities-form-helper-text'>{FormConst.HOTEL_AMENITIES_HEPLER_TEXT}</p>
                                <div id='hotel-amenities-form-fields' className='hotel-amenities-form-fields'>
                                    <Row className='align-items-center'>
                                        <Col xs={12} sm={12} xl={5} className='align-self-start'>
                                            <TextInput name='searchKey' id='search-key' placeholder='Search...' label='Search:' title='Search'
                                                onInput={(e) => {
                                                    e.preventDefault()
                                                    this.searchOptions(e.target.value.toUpperCase(), this.state.initialValues.categoryCode, values)
                                                }
                                                } />
                                            <SelectInput name='categoryCode' id='filter-key' label='Filter by category:' title='Filter by category'
                                                options={this.state.initialValues.filterOptions}
                                                onChange={(e) => {
                                                    e.preventDefault()
                                                    // values.categoryCode = e.target.value
                                                    this.searchOptions(this.state.initialValues.searchKey, e.target.value, values)
                                                }
                                                } />
                                        </Col>
                                        <Col xs={12} sm={12} xl={1} className='align-self-start' />
                                        <Col xs={12} sm={12} xl={5} className='text-center p-0 align-self-start'>
                                            <SelectList
                                                name='addIndices'
                                                id='selected-input'
                                                label='Unselected amenities:'
                                                className='unselected-amenities'
                                                options={this.state.initialValues.filteredList}
                                                title='Unselected amenities' />
                                            <Button
                                                name='Add'
                                                id='add-button'
                                                className='add-button'
                                                onClick={() => { this.addAmenity(values.addIndices, values.hotelAmenities) }} />
                                        </Col>
                                    </Row>
                                    <Row className='align-items-center'>
                                        <Col xs={12} sm={12} xl={12} className='align-self-start'>
                                            <table className='table table-striped selected-amenities-table'>
                                                <caption>
                                                    Selected Hotel Amenities
                                                    <h6 className='text-red mt-1 mb-1'>Please make sure that you add your Accessible Hotel amenities.</h6>
                                                </caption>
                                                <thead>
                                                    <tr>
                                                        {
                                                            this.headers.map((header) => {
                                                                return <th key={header}>{header}</th>
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {values.hotelAmenities.length > 0 ?
                                                        values.hotelAmenities.map((amenity, index) =>
                                                        <tr key={index} className='align-items-center'>
                                                            {!(FormConst.FEMA_AMENITY_CODE === amenity.amenityCode) &&
                                                                <React.Fragment>
                                                                    <td title='Code'>{amenity.amenityCode}</td>
                                                                    <td title='Description'>{amenity.description}</td>
                                                                    <td><SelectInput
                                                                        id={`location-${index}`}
                                                                        name={`hotelAmenities.${index}.proximityLocation`}
                                                                        options={FormConst.HOTEL_AMENITIES_LOCATION_OPTIONS}
                                                                        isrequired='true'
                                                                        title='Location' /></td>
                                                                    <td><TextInput
                                                                        id={`distance-${index}`}
                                                                        name={`hotelAmenities.${index}.distance.value`}
                                                                        type='number'
                                                                        disabled={values.hotelAmenities[index].proximityLocation === FormConst.VALUE_ONSITE}
                                                                        min='0'
                                                                        step='0.1'
                                                                        isrequired='true'
                                                                        title='Distance' /></td>
                                                                    <td>{this.state.distanceUnitLabel}</td>
                                                                    <td>
                                                                        <TextInput id={`open-${index}`} name={`hotelAmenities.${index}.operatingHours.open`} type='time'
                                                                            value={values.hotelAmenities[index].operatingHours.open} 
                                                                            disabled={values.hotelAmenities[index].operatingHours.fullDay} />
                                                                    </td>
                                                                    <td>
                                                                        <TextInput id={`close-${index}`} name={`hotelAmenities.${index}.operatingHours.close`} type='time' 
                                                                            value={values.hotelAmenities[index].operatingHours.close}
                                                                            disabled={values.hotelAmenities[index].operatingHours.fullDay} />
                                                                    </td>
                                                                    <td>24 Hours</td>
                                                                    <td>
                                                                        <TextInput
                                                                            type='checkbox'
                                                                            id={`fullDay-${index}`}
                                                                            name={`hotelAmenities.${index}.operatingHours.fullDay`}
                                                                            key={`hotelAmenities.${index}.operatingHours.fullDay`} />
                                                                    </td>
                                                                    <td><SelectInput
                                                                        id={`charge-${index}`}
                                                                        name={`hotelAmenities.${index}.chargeApplicable`}
                                                                        options={FormConst.OPTIONS_YES_NO}
                                                                        disabled={
                                                                            values.hotelAmenities[index].chargePolicy === FormConst.HOTEL_AMENITIES_CHARGE_POLICY_TYPES.CHARGE_CANNOT_BE_APPLIED
                                                                            || values.hotelAmenities[index].chargePolicy === FormConst.HOTEL_AMENITIES_CHARGE_POLICY_TYPES.CHARGE_MUST_BE_APPLIED
                                                                        }
                                                                        isrequired='true'
                                                                        title='Charge' /></td>
                                                                    <td>
                                                                        <TextInput id={`fee-${index}`} name={`hotelAmenities.${index}.fee`} 
                                                                            type='number'
                                                                            min='0'
                                                                            step='0.1'
                                                                            value={values.hotelAmenities[index].fee}
                                                                            disabled={
                                                                                values.hotelAmenities[index].chargePolicy === FormConst.HOTEL_AMENITIES_CHARGE_POLICY_TYPES.CHARGE_CANNOT_BE_APPLIED
                                                                                || values.hotelAmenities[index].chargeApplicable === FormConst.VALUE_NO
                                                                            }
                                                                            />
                                                                    </td>
                                                                    <td>
                                                                        <a onClick={() => {
                                                                            this.removeAmenity([amenity.value], values)
                                                                        }}>
                                                                            <FaTrashAlt />
                                                                        </a>
                                                                    </td>
                                                                </React.Fragment>}
                                                            </tr>
                                                        )
                                                        : <tr className='table-no-entries'>
                                                            <td colSpan={12}>There are no selected amenities</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                            {
                                                isArrayNotEmpty(values.hotelAmenities) && !this.state.onlyHiddenAmenities
                                                    ? ''
                                                    : <p className='text-center error mt-3 mb-0'>At least one amenity must be added to Selected Hotel Amenities table</p>
                                            }
                                        </Col>
                                    </Row>
                                    {this.state.errorMessage && <p>{this.state.errorMessage}</p>}
                                </div>
                                <FormFooter
                                    form={SideNavEntryMapping.HOTEL_AMENITIES}
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    noReset
                                    submitDisabled={isSubmitting || values.hotelAmenities.length === 0 || this.state.onlyHiddenAmenities} />
                                <FormModal
                                    id='hotel-amenities-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='hotel-amenities-page-delete-modal'
                                    title='Delete All Amenities'
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{FormConst.MODAL_DELETE_ACTION_TEXT}</h6>}
                                    proceed={() => {
                                        this.removeAmenity(values.hotelAmenities.map(amenity => amenity.value), values)
                                        this.setState({ showDeleteModal: false })
                                    }}
                                    cancel={() => { this.setState({ showDeleteModal: false }) }}
                                    show={this.state.showDeleteModal} />
                                <FormModal
                                    id='hotel-amenities-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelAmenitiesResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_AMENITIES_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(HotelAmenities, SideNavEntryMapping.HOTEL_AMENITIES))
